export const eWebinarScript = `
  <script>
    (function(w, d, s, o, f, js, fjs) {
      w['eWidget'] = o;
      w[o] = w[o] || function() {
        (w[o].q = w[o].q || []).push(arguments)
      };
      if (d.getElementById(o)) return;
      js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
      js.id = o;
      js.src = f;
      fjs.parentNode.insertBefore(js, fjs);
    }(window, document, 'script', '_ew', 'https://app.ewebinar.com/widget.js'));

    _ew('init', {
      "root": "w1761735033789",
      "isReview": false,
      "mode": "public",
      "openInPopup": false,
      "for": "Registration",
      "type": "RegForm",
      "source": "",
      "url": "https://naturaily.com/webinar/why-you-should-migrate-from-magento-to-shopify",
      "shortUrl": "https://naturaily.ewebinar.com/webinar/15322",
      "sessions": [],
      "formType": "LatestForm",
      "ewebinar": {
        "title": "Migrating%20from%20Magento%20to%20Shopify",
        "borderRadius": 50,
        "primaryColor": "#ff4e30ff",
        "readableColor": "#ffffff",
        "actionColor": "#ff5e45ff",
        "readableActionColor": "#ffffff",
        "readableOnWhiteColor": "#ff4e30ff",
        "language": "en",
        "duration": 1862
      },
      "showGdprBanner": false,
      "gdprBannerMode": "Off",
      "gdprBannerText": "",
      "hideBranding": false,
      "teamId": "4439",
      "carouselId": "",
      "isWebinarRegPage": false,
      "isMobile": false,
      "initialized": false,
      "multiStepRegistration": false,
      "inSeriesLandingPage": false,
      "button": {
        "btnText": "Sign Up Now",
        "showButtonTimer": false,
        "buttonPrimaryColor": "#ff5e45ff",
        "buttonReadableColor": "#ffffff",
        "align": "Center",
        "isFullWidth": false,
        "step1BtnText": "Complete sign up →"
      },
      "registerForm": {
        "horizontal": false,
        "hideSessionsDropdown": false,
        "showOnlyBuiltInFields": false,
        "showFieldsLabel": true,
        "openLinkInNewWindow": false,
        "showConsentCheckbox": true,
        "formSessionType": "ShowDropdown",
        "consentCheckboxText": "I agree to receive marketing communications about your products and services, including notifications about offers, content, and updates that may contain commercial information.",
        "fields": [{
          "__typename": "RegistrationFormField",
          "fieldName": "Full name",
          "propertyName": "name",
          "type": "Text",
          "subType": null,
          "isRequired": true,
          "isRemovable": false,
          "note": "",
          "options": null
        }, {
          "__typename": "RegistrationFormField",
          "fieldName": "Work email",
          "propertyName": "email",
          "type": "Email",
          "subType": null,
          "isRequired": true,
          "isRemovable": false,
          "note": "",
          "options": null
        }, {
          "__typename": "RegistrationFormField",
          "fieldName": "Company",
          "propertyName": "company_1",
          "type": "Text",
          "subType": null,
          "isRequired": true,
          "isRemovable": true,
          "note": "",
          "options": null
        }, {
          "__typename": "RegistrationFormField",
          "fieldName": "Role",
          "propertyName": "role",
          "type": "Text",
          "subType": null,
          "isRequired": true,
          "isRemovable": true,
          "note": "",
          "options": null
        }]
      }
    });
    
    window.ewInit && window.ewInit();
  </script>
`;
